import { Link } from "react-router-dom";

export default function LegalPending({ title }) {
  return <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#151515", color: "#f7f7f7", fontFamily: "Inter, Arial, sans-serif" }}>
    <div style={{ maxWidth: 560, textAlign: "center" }}>
      <p style={{ color: "#e8b968", letterSpacing: 2, textTransform: "uppercase", fontSize: 12 }}>AgendaCut</p>
      <h1 style={{ fontSize: 36, margin: "12px 0" }}>{title}</h1>
      <p style={{ color: "#b9b8b7", lineHeight: 1.6 }}>Conteúdo em preparação. Esta página ainda não apresenta o documento jurídico definitivo.</p>
      <Link to="/" style={{ display: "inline-block", marginTop: 22, color: "#e8b968" }}>Voltar à página inicial</Link>
    </div>
  </main>;
}
